import { render, staticRenderFns } from "./fieldMetadataMultiSelect.vue?vue&type=template&id=28ee2a10&"
import script from "./fieldMetadataMultiSelect.vue?vue&type=script&lang=js&"
export * from "./fieldMetadataMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports